import { IoSettingsOutline } from "react-icons/io5"
import HeaderLabel from "../headerLabel"
import { BaseSectionWrapper } from "./styles"
import { useTranslation } from "react-i18next"
import EventIcon from "@assets/svg/EventIcon.svg?react"
import CustomSelect from "@Common/CustomSelect"
import { IGetMasterDataEventType } from "src/services/Automations/GetMasterData/types"
import { useMemo } from "react"

interface IProps {
	listData: IGetMasterDataEventType[]
}
export default function BaseSection({ listData }: IProps) {
	const { t, i18n: { language } } = useTranslation()

	const eventsList = useMemo(() => {
		const listOfData = listData?.map((item) => {
			return {
				label: language === "ar" ? item.description : item.descriptionEn,
				value: item.id.toString(),
			}
		})
		return listOfData ?? []
	}, [listData, language])
	return (
		<BaseSectionWrapper>
			<div className='firstSection'>
				<HeaderLabel
					icons={<IoSettingsOutline />}
					label={t("AutomationCentre.base")}
				/>
				<div className='banner'>
					{t("AutomationCentre.banner_example")}
				</div>
			</div>
			<div className='lastSection'>
				<HeaderLabel
					icons={<EventIcon />}
					label={t("AutomationCentre.event")}
					tooltip='test'
				/>
				<div className='containerGuestLogin'>
					<CustomSelect
						data={eventsList}
						name='eventType'
						registerOptions={{
							required: {
								value: true,
								message: t("COMMON.REQUIRED"),
							},
						}}
					/>
				</div>
			</div>
		</BaseSectionWrapper>
	)
}
